import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {
    user: any;
    constructor(public userblockService: UserblockService) {

    }

    ngOnInit() {
        this.user = this.userblockService.getUser();
    }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/layout/sidebar/userblock/userblock.component.ts